import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { WeblinkMainComponent } from './weblink/weblink-main/weblink-main.component';


const appRoutes: Routes = [
  {
    path: '',
    redirectTo: '/weblink',
    pathMatch: 'full'
  },
  {
    path: 'weblink',
    component: WeblinkMainComponent
    //loadChildren: './weblink/weblink.module#WeblinkModule'
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes)
  ],
  exports: [
    RouterModule
  ],
  declarations: []
})
export class AppRoutingModule { }
